import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  field: {
    padding: theme.spacing(0, 2)
  }
}));

export default useStyles;
